// Chakra imports
import {
  Box,
  VStack,
  HStack,
  FormControl,
  Input,
  InputGroup,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Heading,
  Circle,
  Center,
  Icon,
  Avatar,
  useDisclosure,
  useColorModeValue,
  useToast,
  Text,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";
import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import Pattern from "assets/images/pattern1.png";

// Custom components
import Card from "components/card/Card.js";
import { useDropzone } from "react-dropzone";
//import useIdentityPayKYC from 'react-identity-kyc'
// Assets
import {
  FiUserX,
  FiUserCheck,
  FiArrowLeft,
  FiChevronRight,
} from "react-icons/fi";

export default function KycInfo(props) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { user, getUser, ...rest } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isBvnVerifyOpen,
    onOpen: onBvnVerifyOpen,
    onClose: onBvnVerifyClose,
  } = useDisclosure();

  const {
    isOpen: isIdentityVerifyOpen,
    onOpen: onIdentityVerifyOpen,
    onClose: onIdentityVerifyClose,
  } = useDisclosure();

  const {
    isOpen: isAddressVerifyOpen,
    onOpen: onAddressVerifyOpen,
    onClose: onAddressVerifyClose,
  } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [bvn, setBvn] = useState("");
  const [address, setAddress] = useState({
    houseNumber: "",
    street: "",
    city: "",
    state: "",
  });
  const [identity, setIdentity] = useState({
    type: "",
    idNumber: "",
    idImage: "",
  });

  const onDrop = useCallback((acceptedFiles) => {
    setImageLoading(true);
    acceptedFiles.map((file) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const mimeType = getFileType(file);
        // check if the MIME type is an image
        if (mimeType && mimeType.split('/')[0] !== 'image') { 
          toast({
            title: "File type uploaded not allowed",
            status: "info",
            duration: 9000,
            position: "top-right",
            isClosable: true,
          });
          setImageLoading(false);
          return;
        }
        identity.idImage = e.target.result;
        setIdentity(identity);
        setImageLoading(false);
      };
      reader.readAsDataURL(file);
      return file;
    });
  }, []);

  const getFileType = (file) => {
    const fileType = file.type;
    if (!fileType) {
      return null;
    }
    const mimeType = fileType.split(';')[0];
    return mimeType;
  };

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({ onDrop });

  const toast = useToast();
  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;

  const textColorPrimary = useColorModeValue("secondaryGray.500", "white");
  const textColorSecondary = useColorModeValue("gray.800", "white");

  const states = [
    "FCT",
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara",
  ];

  const submitKYC = async () => {
    try {
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/kyc",
        { bvn, address, identity },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (response.success) {
        setLoading(false);
        toast({
          title: response.message || "KYC request submitted sucessfully",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        getUser();
        onClose();
      }
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  /*
  const config = {
    first_name:user.firstName,
    last_name:user.lastName,
    email:user.email,
    merchant_key:"e7q2uy34kbnedyqc1w2r:8DBfwa0VHdm6t0LWYo5_UYgD3Nk",
    user_ref:user._id,
    is_test:false,  //set this to through for a test
    callback:(response)=>{ 
      if(response.hasOwnProperty('status') && response.status==="success" && response.hasOwnProperty('data') && response.data.hasOwnProperty('data') && response.data.status){
        onClose();
        processKyc(response.data);
      }else{
        toast({
          title:"We could not verify ID, please try again",
          status: 'error',
          duration: 9000,
          position:'top-right',
          isClosable: true,
        });
      } 
    }
  }
  const verifyWithIdentity = useIdentityPayKYC(config);*/

  useEffect(() => {

  }, [identity]);


  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={"md"}>
        <ModalOverlay />
        <ModalContent color={textColorSecondary}>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
              color={textColorPrimary}
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box mt="4">
                <Heading
                  as="h4"
                  color={textColorSecondary}
                  fontSize={{ base: "xl", lg: "2xl" }}
                >
                  Verify your identity
                </Heading>
              </Box>
              <Box>
                <Text color={textColorSecondary}>
                  In order to complete your registration, please complete the
                  KYC verification process below
                </Text>
              </Box>
              <Box>
                <VStack spacing={4} align="stretch">
                  <Box
                    w="100%"
                    minH="40px"
                    mt="4"
                    background="blue.300"
                    p="4"
                    borderRadius={"10"}
                    onClick={onAddressVerifyOpen}
                  >
                    <HStack>
                      <Box width="70%" textAlign="start" color="white">
                        <Text>Address</Text>
                        <Text fontSize="xs">Enter your valid address</Text>
                      </Box>
                      <Box width="15%">
                        <Circle
                          width="35px"
                          height="35px"
                          background="brand.500"
                        >
                          {address.houseNumber !== "" &&
                          address.street !== "" &&
                          address.city !== "" &&
                          address.state != "" ? (
                            <Icon
                              as={FiUserCheck}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          ) : (
                            <Icon
                              as={FiUserX}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          )}
                        </Circle>
                      </Box>
                      <Box width="15%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color="white"
                        />
                      </Box>
                    </HStack>
                  </Box>
                  <Box
                    w="100%"
                    minH="40px"
                    mt="4"
                    background="blue.300"
                    p="4"
                    borderRadius={"10"}
                    onClick={onBvnVerifyOpen}
                  >
                    <HStack>
                      <Box width="70%" textAlign="start" color="white">
                        <Text>BVN</Text>
                        <Text fontSize="xs">Bank Verification Number</Text>
                      </Box>
                      <Box width="15%">
                        <Circle
                          width="35px"
                          height="35px"
                          background="brand.500"
                        >
                          {bvn !== "" ? (
                            <Icon
                              as={FiUserCheck}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          ) : (
                            <Icon
                              as={FiUserX}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          )}
                        </Circle>
                      </Box>
                      <Box width="15%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color="white"
                        />
                      </Box>
                    </HStack>
                  </Box>

                  <Box
                    w="100%"
                    minH="40px"
                    mt="4"
                    background="blue.300"
                    p="4"
                    borderRadius={"10"}
                    onClick={onIdentityVerifyOpen}
                  >
                    <HStack>
                      <Box width="70%" textAlign="start" color="white">
                        <Text>Identity Card</Text>
                        <Text fontSize="xs">
                          International or Driver License or NIN
                        </Text>
                      </Box>
                      <Box width="15%">
                        <Circle
                          width="35px"
                          height="35px"
                          background="brand.500"
                        >
                          {identity.idNumber !== "" &&
                          identity.idImage !== "" ? (
                            <Icon
                              as={FiUserCheck}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          ) : (
                            <Icon
                              as={FiUserX}
                              width="18px"
                              height="18px"
                              color="white"
                            />
                          )}
                        </Circle>
                      </Box>
                      <Box width="15%">
                        <Icon
                          as={FiChevronRight}
                          width="20px"
                          height="20px"
                          color="white"
                        />
                      </Box>
                    </HStack>
                  </Box>

                  <Box mt="3">
                    <Button
                      variant="primary"
                      isLoading={loading}
                      loadingText="Wait"
                      color={"white"}
                      w="full"
                      borderRadius="20"
                      onClick={(e) => {
                        e.preventDefault();
                        submitKYC();
                      }}
                    >
                      Submit KYC Request
                    </Button>
                  </Box>
                </VStack>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isBvnVerifyOpen} onClose={onBvnVerifyClose} size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
              color="white"
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box mt="4">
                <Heading
                  as="h4"
                  color={textColorSecondary}
                  fontSize={{ base: "xl", lg: "2xl" }}
                >
                  BVN Verification
                </Heading>
              </Box>
              <Box mt="3">
                <Text color={textColorSecondary}>
                  Enter your 11 digits BVN number
                </Text>
              </Box>

              <Box mt="1">
                <FormControl id="bvn" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      maxLength={11}
                      defaultValue={bvn}
                      color={textColorSecondary}
                      onChange={(e) => {
                        setBvn(e.target.value);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>
              </Box>

              <Box mt="3">
                <Button
                  variant="primary"
                  color={"white"}
                  w="full"
                  borderRadius="20"
                  onClick={(e) => {
                    e.preventDefault();
                    onBvnVerifyClose();
                  }}
                >
                  Continue
                </Button>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isAddressVerifyOpen}
        onClose={onAddressVerifyClose}
        size={"md"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
              color="white"
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box mt="4">
                <Heading
                  as="h4"
                  color={textColorSecondary}
                  fontSize={{ base: "xl", lg: "2xl" }}
                >
                  Address Information
                </Heading>
              </Box>
              <Box>
                <Text color={textColorSecondary}>
                  Provide your current address
                </Text>
              </Box>

              <Box mt="3">
                <Text color={textColorSecondary} fontWeight="bold">
                  House Number
                </Text>
              </Box>
              <Box mt="1">
                <FormControl id="housenumber" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      maxLength={11}
                      color={textColorSecondary}
                      defaultValue={address.houseNumber}
                      onChange={(e) => {
                        address.houseNumber = e.target.value;
                        setAddress(address);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>
              </Box>

              <Box mt="3">
                <Text color={textColorSecondary} fontWeight="bold">
                  Street
                </Text>
              </Box>
              <Box mt="1">
                <FormControl id="street" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      maxLength={150}
                      defaultValue={address.street}
                      color={textColorSecondary}
                      onChange={(e) => {
                        address.street = e.target.value;
                        setAddress(address);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>
              </Box>

              <SimpleGrid columns={{ sm: 1, md: 2 }} spacing="2">
                <Box>
                  <Box mt="3">
                    <Text color={textColorSecondary} fontWeight="bold">
                      City
                    </Text>
                  </Box>
                  <Box mt="1">
                    <FormControl id="city" isRequired>
                      <InputGroup>
                        <Input
                          type="text"
                          maxLength={11}
                          color={textColorSecondary}
                          defaultValue={address.city}
                          onChange={(e) => {
                            address.city = e.target.value;
                            setAddress(address);
                          }}
                          borderRadius="20"
                        />
                      </InputGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box>
                  <Box mt="3">
                    <Text color={textColorSecondary} fontWeight="bold">
                      State
                    </Text>
                  </Box>
                  <Box mt="1">
                    <FormControl id="state" isRequired>
                      <Select
                        placeholder="Select option"
                        defaultValue={address.state}
                        onChange={(e) => {
                          address.state = e.target.value;
                          setAddress(address);
                        }}
                        borderWidth="1"
                        borderRadius="20"
                      >
                        {states.map((state) => (
                          <option value={state}>{state}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              </SimpleGrid>

              <Box mt="3">
                <Button
                  variant="primary"
                  color={"white"}
                  w="full"
                  borderRadius="20"
                  onClick={(e) => {
                    onAddressVerifyClose();
                  }}
                >
                  Continue
                </Button>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isIdentityVerifyOpen}
        onClose={onIdentityVerifyClose}
        size={"md"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
              color="white"
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box mt="4">
                <Heading
                  as="h4"
                  color={textColorSecondary}
                  fontSize={{ base: "xl", lg: "2xl" }}
                >
                  ID Verification
                </Heading>
              </Box>

              <Box mt="3">
                <Text fontWeight="bold" color={textColorSecondary}>
                  Identity Type
                </Text>
              </Box>
              <Box mt="1">
                <FormControl id="state" isRequired>
                  <Select
                    placeholder="Select option"
                    onChange={(e) => {
                      identity.type = e.target.value;
                      setIdentity(identity);
                    }}
                    borderWidth="1"
                    borderRadius="20"
                  >
                    <option value="NIGERIAN_NIN">
                      National Identification Number
                    </option>
                    <option value="NIGERIAN_INTERNATIONAL_PASSPORT">
                      International Passport
                    </option>
                    <option value="NIGERIAN_PVC">Permanent Voters Card</option>
                    <option value="NIGERIAN_DRIVERS_LICENSE">
                      Drivers License
                    </option>
                  </Select>
                </FormControl>
              </Box>

              <Box mt="3">
                <Text fontWeight="bold" color={textColorSecondary}>
                 ID Number
                </Text>
              </Box>
              <Box mt="1">
                <FormControl id="id" isRequired>
                  <InputGroup>
                    <Input
                      type="text"
                      maxLength={20}
                      color={textColorSecondary}
                      onChange={(e) => {
                        identity.idNumber = e.target.value;
                        setIdentity(identity);
                      }}
                      borderRadius="20"
                    />
                  </InputGroup>
                </FormControl>
              </Box>

              <Box mt="3">
                <Text fontWeight="bold" color={textColorSecondary}>
                  Upload ID (<Text color="brand.700" as="span">.jpg, .jpeg, .png</Text>)
                </Text>
              </Box>

              <Box
                {...getRootProps()}
                textAlign="center"
                width="100%"
                borderWidth={1}
                borderColor="#CCCCCC"
                borderRadius="15"
                height="150"
              >
                <Center width="100%" height="130">
                  <VStack>
                    <Box>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <Text>Drag ID image here ...</Text>
                      ) : (
                        <Text>Drag ID images here</Text>
                      )}
                    </Box>
                    <Box>
                      <Button
                        colorScheme="brand"
                        isLoading={imageLoading}
                        loadingText={"Uploading...."}
                      >
                        Select Image
                      </Button>
                    </Box>
                    <Box>
                      {identity.idImage !== "" && (
                        <Avatar
                          size="sm"
                          name="Id Image"
                          src={identity.idImage}
                        />
                      )}
                    </Box>
                  </VStack>
                </Center>
              </Box>

              <Box mt="3">
                <Button
                  variant="primary"
                  color={"white"}
                  w="full"
                  borderRadius="20"
                  isLoading={imageLoading}
                  loadingText={"Wait...."}
                  onClick={(e) => {
                    e.preventDefault();
                    onIdentityVerifyClose();
                  }}
                >
                  Continue
                </Button>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      {!user.identityVerified && user.kycStatus === "invalid" && (
        <KycNotStarted onOpen={onOpen} user={user} />
      )}
      {/*!user.identityVerified && user.bvnVerified && <IdentityNotStarted onOpen={onOpen} user={user} />*/}
      {/*!user.bvnVerified && user.identityVerified && <BvnNotStarted onOpen={onOpen} user={user} />*/}
      {!user.identityVerified && user.kycStatus === "pending" && (
        <KycPending user={user} />
      )}
    </>
  );
}

const KycNotStarted = (props) => {
  const { user, onOpen } = props;
  return (
    <Card
      shadow="md"
      background="blue.500"
      backgroundImage={`url(${Pattern})`}
      backgroundPosition="center center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
    >
      <VStack>
        <Box textAlign="start">
          <Text
            color="white"
            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            Hi
          </Text>
          <Text
            color="white"
            fontWeight="bold"
            fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            {user.firstName} {user.lastName}
          </Text>
          <Text
            as="h3"
            color="white"
            textAlign="start"
            fontSize={{ base: "sm", sm: "md", md: "lg", lg: "xl" }}
            mt={{ base: "5px", "2xl": "5px" }}
          >
            Verify your identity to get a{" "}
            <Text as="span" color="orange.600">
              Swaptrex
            </Text>{" "}
            Virtual Account and Virtual Card
          </Text>
        </Box>
        <Box width="100%">
          <Button
            mt="5"
            colorScheme="white"
            background="#fff"
            color="#000"
            variant="solid"
            fontSize={{ base: "xs", sm: "sm", md: "sm", lg: "md" }}
            onClick={onOpen}
          >
            Proceed
          </Button>
        </Box>
      </VStack>
    </Card>
  );
};

const IdentityNotStarted = (props) => {
  const { user, onOpen } = props;
  return (
    <Card shadow="md" background="blue">
      <VStack>
        <Box textAlign="start">
          <Text
            color="white"
            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            Hi
          </Text>
          <Text
            color="white"
            fontWeight="bold"
            fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            {user.firstName} {user.lastName}
          </Text>
          <Text
            as="h3"
            color="white"
            textAlign="start"
            fontSize={{ base: "sm", sm: "sm", md: "sm", lg: "sm" }}
            mt={{ base: "5px", "2xl": "5px" }}
          >
            You are just one more step away from getting your Virtual Card but
            we need to verify your identity, please supply us with a{" "}
            <Text as="span" color="#61E8E1">
              {" "}
              Valid Identity Document
            </Text>
            &nbsp; information
          </Text>
        </Box>
        <Box width="100%">
          <Button
            mt="5"
            colorScheme="white"
            background="#fff"
            color="#000"
            variant="solid"
            onClick={onOpen}
          >
            Proceed
          </Button>
        </Box>
      </VStack>
    </Card>
  );
};

const BvnNotStarted = (props) => {
  const { user, onOpen } = props;
  return (
    <Card shadow="md" background="blue">
      <VStack>
        <Box textAlign="start">
          <Text
            color="white"
            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            Hi
          </Text>
          <Text
            color="white"
            fontWeight="bold"
            fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            {user.firstName} {user.lastName}
          </Text>
          <Text
            as="h3"
            color="white"
            textAlign="start"
            fontSize={{ base: "sm", sm: "sm", md: "sm", lg: "sm" }}
            mt={{ base: "5px", "2xl": "5px" }}
          >
            You are just one more step away from getting your Virtual Card but
            we need to verify your BVN, please supply us with your{" "}
            <Text as="span" color="#61E8E1">
              {" "}
              BVN Information
            </Text>
          </Text>
        </Box>
        <Box width="100%">
          <Button
            mt="5"
            colorScheme="white"
            background="#fff"
            color="#000"
            variant="solid"
            onClick={onOpen}
          >
            Proceed
          </Button>
        </Box>
      </VStack>
    </Card>
  );
};

const KycPending = (props) => {
  const { user, onOpen } = props;
  return (
    <Card
      shadow="md"
      background="blue.500"
      backgroundImage={`url(${Pattern})`}
      backgroundPosition="center center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
    >
      <VStack>
        <Box textAlign="start">
          <Text
            color="white"
            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            Hi
          </Text>
          <Text
            color="white"
            fontWeight="bold"
            fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            {user.firstName} {user.lastName}
          </Text>
          <Text
            as="h3"
            color="white"
            textAlign="start"
            fontSize={{ base: "sm", sm: "md", md: "lg", lg: "xl" }}
            mt={{ base: "5px", "2xl": "5px" }}
          >
            We are currently reviewing your
            <Text as="span" color="#61E8E1">
              {" "}
              KYC Information.
            </Text>
            &nbsp; This process will be completed within 24 hrs
          </Text>
        </Box>
      </VStack>
    </Card>
  );
};
